import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import { DataTable } from '../components/ui/data-table';
import { ColumnDef } from '@tanstack/react-table';
import { Eye } from 'lucide-react';
import { crearDepurador } from '../utils/depurador';

interface Cargo {
  c_id: number;
  c_codigo: string;
  c_nombre: string;
  c_puntaje: number | null;
  e_codigo: string;
  e_nombre: string;
  a_codigo: string;
  a_nombre: string;
}

const columns: ColumnDef<Cargo>[] = [
  {
    accessorKey: 'c_id',
    header: 'ID',
  },
  {
    accessorKey: 'c_codigo',
    header: 'Código',
  },
  {
    accessorKey: 'c_nombre',
    header: 'Nombre',
  },
  {
    accessorKey: 'c_puntaje',
    header: 'Puntaje',
    cell: ({ row }) => row.getValue('c_puntaje') || '-',
  },
  {
    accessorKey: 'e_codigo',
    header: 'Escalafón',
    cell: ({ row }) => `${row.getValue('e_codigo')} - ${row.getValue('e_nombre')}`,
  },
  {
    accessorKey: 'a_codigo',
    header: 'Agrupamiento',
    cell: ({ row }) => `${row.getValue('a_codigo')} - ${row.getValue('a_nombre')}`,
  },
  {
    id: 'acciones',
    header: 'Acciones',
    cell: ({ row }) => (
      <button 
        className="p-2 rounded-full hover:bg-gray-100"
        onClick={() => depurador.info('Ver detalles:', row.original)}
      >
        <Eye className="w-6 h-6 text-gray-500" />
      </button>
    ),
  },
];

// Crear un depurador específico para el módulo de Cargos
const depurador = crearDepurador({ modulo: 'Cargos' });

export default function Cargos() {
  const [cargos, setCargos] = useState<Cargo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCargos = async () => {
      try {
        const response = await apiClient.get('/api/cargos');
        setCargos(response.data);
        setLoading(false);
      } catch (err: any) {
        depurador.grupo('Error al cargar cargos');
        depurador.error('Error completo:', err);
        depurador.error('Mensaje de error:', err.message);
        depurador.error('Response:', err.response);
        depurador.finGrupo();
        setError('Error al cargar los cargos');
        setLoading(false);
      }
    };

    fetchCargos();
  }, []);

  if (loading) return <div className="flex justify-center items-center h-screen">Cargando...</div>;
  if (error) return <div className="text-red-500 text-center p-4">{error}</div>;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Nomenclador de Cargos</h1>
      <DataTable columns={columns} data={cargos} />
    </div>
  );
}